import React, { useState ,useContext, useEffect } from "react";
import "./navbar.css";
import { useNavigate } from "react-router-dom";
import strings from "../../utils/property-file/navbar.json";
import constants from "../../utils/constants";
import LogoutPopup from "../navbar/logoutPopup"
import { useLocation } from "react-router-dom";
import { FetchedCompanyLogoContext } from "../fetchedCompanyLogo";
import  HourHiveLogo   from "../../Asset/Images/logoImage.png";
import  HourHiveNewLogo   from "../../Asset/Images/hh-logo.svg";
import api from "../../services/api";
import Favicon from "react-favicon";
import { AttendanceRequestContext } from "../requestContext";
import { toast } from "react-toastify";
import BroadcastIcon from "../../Asset/Images/broadcast-icon.svg"

function Navbar(props) {
  const nav = useNavigate();
  const [modalShow, setModalShow] = useState(false);
  const { companyLogo, setCompanyLogo } = useContext(FetchedCompanyLogoContext);
  const location = useLocation();
  const [toggle, setToggle] = useState(false);
  let dashboard = false, companyProfile = false, employeeProfile = false, employeeData = false, setting = false, manageLeave = false ,requestAttendance=false , broadcast=false,markAttendance = false;
  let company_name = localStorage.getItem("company_info");
  let userName =localStorage.getItem("userName");
  const isSuperAdmin= localStorage.getItem("isSuperAdmin");
  const {attendanceRequestCount, setAttendanceRequestCount} = useContext(AttendanceRequestContext);
  const isBluewingsCustomer = localStorage.getItem('isBluewingsCustomer')
  
  if (location.pathname === constants.navigationLink.dashboardLink) {
    dashboard = true;
  }
  if (location.pathname === constants.navigationLink.requestsAttendance) {
    requestAttendance = true;
  }
  if (location.pathname === constants.navigationLink.companyProfile) {
    companyProfile = true;
  }
  if (location.pathname === constants.navigationLink.empProfile) {
    employeeProfile = true;
  }
  if (location.pathname === constants.navigationLink.employeeData) {
    employeeData = true;
  }
  if (location.pathname === constants.navigationLink.setting) {
    setting = true;
  }
  if (location.pathname === constants.navigationLink.broadcast || location.pathname === constants.navigationLink.createBroadCast || location.pathname === constants.navigationLink.detailBroadcast) {
    broadcast = true;
  }
  if (location.pathname === constants.navigationLink.changePassword) {
    setting = true;
  }
  if (location.pathname === constants.navigationLink.manageLeaves || location.pathname === constants.navigationLink.scheduleLeaves || location.pathname === constants.navigationLink.scheduleHoliday) {
    manageLeave = true;
  }
  if (location.pathname === constants.navigationLink.markAttendance) {
    markAttendance = true;
  }

  const fetchCompanyLogoDetails=async()=>{
    try
    {
      const response=await api.fetchCompanyLogo();
      if(response && response.data)
      {
        const data= JSON.parse(response.data);
        if(response.success)
        {
          setCompanyLogo(data.companyLogo? (data.companyLogo!=""?data.companyLogo : HourHiveLogo) :HourHiveLogo);
        }
        else
        {
          setCompanyLogo(HourHiveLogo);
        }
      }
    }
    catch(error)
    {
      setCompanyLogo(HourHiveLogo)
    }
  }

  const fetchRequestCount = async () =>{
    try{
      const response = await api.getAttendanceRequestCount();
      if(response.success && response.data){
        const data = JSON.parse(response.data);
        setAttendanceRequestCount(data.requestCount.count);
      }
      else{
        setAttendanceRequestCount(null);
      }
    }
    catch(error){
      toast.error(strings.somethingWentWrong)
    }
  }

  useEffect(()=>{
    fetchCompanyLogoDetails();
    fetchRequestCount();
  },[])



  const [width, setWidth] = useState(0);
  const handleResize = () => {
    setWidth(window.innerWidth);
  };

  useEffect(() => {
    setWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <div className="nav-parent" style={{display: props.display && props.display}} >
      <Favicon url={companyLogo ?companyLogo : HourHiveLogo}/>
      <div className="main-container-navbar">
        <div className="logo-container-hh">
          <img className="logo-image" src={HourHiveNewLogo} alt="logo" />
        </div>

        <div className="navigation-container-hh-new">
          <div   onClick={() => {
                nav("/dashboard");
              }} className={dashboard ? "link-logo-name-active" :"link-logo-name"}>
            <div className="icon-name"><i class="ri-dashboard-line"></i></div>
            <div className="link-name">{strings.dashboard}</div>
          </div>
           <div onClick={() => {
                nav("/company-profile");
              }}  className={companyProfile ? "link-logo-name-active" :"link-logo-name"}>
            <div className="icon-name"><i class="ri-organization-chart"></i></div>
            <div className="link-name">{strings.comProfile}</div>
          </div>
           <div  onClick={() => {
                nav("/employee-profile");
              }} className={employeeProfile || employeeData ? "link-logo-name-active" :"link-logo-name"}>
            <div className="icon-name"><i class="ri-user-3-line"></i></div>
            <div className="link-name">{strings.empProfile} </div>
          </div>

          <div  onClick={() => {
                nav("/manage-leaves");
              }}  className={manageLeave ? "link-logo-name-active" :"link-logo-name"}>
            <div className="icon-name"><i class="ri-calendar-2-line"></i></div>
            <div className="link-name">{strings.manageLeave}</div>
          </div>
            <div  onClick={() => {
                nav(constants.navigationLink.markAttendance);
              }}  className={markAttendance ? "link-logo-name-active" :"link-logo-name"}>
            <div className="icon-name"><i class="ri-checkbox-circle-line"></i></div>
            <div className="link-name">{strings.markAttendance}</div>
          </div>
           <div onClick={() => {
                nav(constants.navigationLink.requestsAttendance);
              }} className={requestAttendance ? "link-logo-name-active" :"link-logo-name"}>
            <div className="icon-name"><i class="ri-user-shared-2-line"></i></div>
            <div className="link-name">{strings.labelRequest} {attendanceRequestCount!=null && attendanceRequestCount!=0? <span> ({attendanceRequestCount})</span> : ""}</div>
          </div>
          {!isBluewingsCustomer &&
           <div onClick={() => {
                nav(constants.navigationLink.broadcast);
              }}  className={broadcast ? "link-logo-name-active" :"link-logo-name"}>
            <div className="icon-name"><i class="ri-broadcast-line"></i></div>
            <div className="link-name">{strings.broadcastFeature}</div>
          </div> }

          <div  onClick={() => {
                nav(constants.navigationLink.setting);
              }} className={setting ? "link-logo-name-active" :"link-logo-name"} >
            <div className="icon-name"><i class="ri-settings-2-line"></i></div>
            <div className="link-name">{strings.settings}</div>
          </div>
        </div>
          
      </div>
      {!isBluewingsCustomer &&
         <div className="navigation-container-hh-new logout-link">
<div onClick={()=>{
  setModalShow(true)
}} className="link-logout-name">
            <div className="icon-name"><i class="ri-logout-circle-r-line"></i></div>
            <div className="link-name">Logout</div>
          </div>
        </div>
}
      <LogoutPopup
        show={modalShow}
        onHide={() => setModalShow(false)}
      />
    </div>
  );
}
export default Navbar;
